module.exports = __webpack_public_path__ + "static/media/sample_4-02.e90ecff2.jpg";